import { render, staticRenderFns } from "./ErrorMsgModal.vue?vue&type=template&id=c83271b2&scoped=true"
import script from "./ErrorMsgModal.vue?vue&type=script&lang=js"
export * from "./ErrorMsgModal.vue?vue&type=script&lang=js"
import style0 from "./ErrorMsgModal.vue?vue&type=style&index=0&id=c83271b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c83271b2",
  null
  
)

export default component.exports